import template from './countdown.tpl.html';
import controller from './countdown.controller';

export default function() {
    return {
        restrict: 'E',
        scope: {
            viewmode: '@',
            redirecturl: '@',
            noofviewers: '@',
            showviewcount: '@'
        },
        controller: ['$scope', '$interval', 'watchService', controller],
        controllerAs: 'ctrl',
        bindToController: true,
        template: template
    };
}
